import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, Wind, Lightbulb, Activity } from 'lucide-react';
export function ProblemSection() {
  const triggers = [{
    icon: <Wind className="w-6 h-6 text-gold" data-id="element-192" />,
    text: 'El clic del aire acondicionado'
  }, {
    icon: <Lightbulb className="w-6 h-6 text-gold" data-id="element-193" />,
    text: 'La luz de la calle que se filtra por la ventana'
  }, {
    icon: <Activity className="w-6 h-6 text-gold" data-id="element-194" />,
    text: "El 'Reflejo de Moro' que se activa al detectar el cambio de gravedad"
  }];
  return <section className="bg-navy text-cream py-24 px-6 relative overflow-hidden" data-id="element-195">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent" data-id="element-196"></div>

      <div className="max-w-4xl mx-auto" data-id="element-197">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-198">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-gold" data-id="element-199">
            El problema no es tu bebé.
          </h2>
          <p className="text-xl leading-relaxed text-cream/90 max-w-3xl mx-auto" data-id="element-200">
            El problema es que te han vendido dos mentiras: o te resignas a no
            dormir por años, o dejas que tu hijo colapse de agotamiento nervioso
            llorando en una habitación oscura.
          </p>
        </motion.div>

        <div className="bg-navy-light rounded-2xl p-8 md:p-12 border border-gold/10 shadow-xl" data-id="element-201">
          <p className="text-lg mb-8 text-center text-cream/80" data-id="element-202">
            La mayoría de los bebés en USA se despiertan por factores que nadie
            te explica:
          </p>

          <div className="grid gap-6 md:grid-cols-3 mb-10" data-id="element-203">
            {triggers.map((trigger, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex flex-col items-center text-center p-6 rounded-xl bg-navy/50 border border-gold/5" data-id="element-204">
                <div className="bg-navy p-4 rounded-full mb-4 shadow-inner" data-id="element-205">
                  {trigger.icon}
                </div>
                <p className="font-medium text-cream/90" data-id="element-206">{trigger.text}</p>
              </motion.div>)}
          </div>

          <div className="text-center" data-id="element-207">
            <div className="inline-flex items-center justify-center gap-3 bg-gold/10 text-gold px-6 py-3 rounded-full font-semibold border border-gold/20" data-id="element-208">
              <AlertCircle className="w-5 h-5" data-id="element-209" />
              Estás luchando contra la biología de tu bebé, no contra su
              voluntad.
            </div>
          </div>
        </div>
      </div>
    </section>;
}